import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Chart, StockChart } from "angular-highcharts";
// import { ResizedEvent } from 'angular-resize-event';
import { ResizedEvent } from 'angular-resize-event-package';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { dateTimeToDate, dateTimeToTime, secondsToTime, percentages, round, responsiveChart, getGroupingValue } from "../../../widget-helpers/helpers";
import { gridItemType, widgetAppearanceType, GroupingValue } from "src/app/enums";
import { colorThemes, multiColorThemes } from "../../common/chartThemes";
import { ChartUtilitiesService } from "../../../widget-utilities/chart-utilities.service";
import { DialogDownloadTableComponent } from "src/app/common/dialogs/dialog-download-table/dialog-download-table.component";
import { MatDialog } from "@angular/material/dialog";
import * as Highcharts from "highcharts";
import HC_exporting from "highcharts/modules/exporting";
import HC_exportData from "highcharts/modules/export-data"
// import { DepFlags } from "@angular/compiler/src/core";
HC_exporting(Highcharts);
HC_exportData(Highcharts);

@Component({
    selector: 'app-reports-barchart',
    templateUrl: './reports-barchart.component.html',
    styleUrls: ['./reports-barchart.component.scss'],
    standalone: false
})

export class ReportsBarchartComponent implements OnInit, OnDestroy {
    @Input() public data;
    @Input() public columns;
    @Input() public groupByTime: GroupingValue;
    @Input() public gridItem;
    @Input() public isStandAlone: boolean;
    @Input() notifier: Subject<any>;
    @Input() isInWizard: boolean;
    @Input() public stepper;
    @Input() public downloadDialogNotifier: Subject<any>;
    @Input() public reportCode;
    @Input() public reportInfo;
    @Input() public isChart: boolean;

    @ViewChild('chartEl') htmlChart: ElementRef<HTMLDivElement>;

    public Highcharts = Highcharts;
    private ngUnsubscribe = new Subject<void>();
    private longestStringLength: number = 0;

    private legendTitle: string;
    private xTitle: string;
    private yTitle: string;

    private legendFontSize: string;
    private legendElementsFontSize: string;
    private xTitleFontSize: string;
    private xLabelsFontSize: string;
    private yTitleFontSize: string;
    private yLabelsFontSize: string;

    private legendColor: string;
    private legendElementsColor: string;
    private xTitleColor: string;
    private xLabelsColor: string;
    private yTitleColor: string;
    private yLabelsColor: string;

    private splicedData: any;

    public chart: StockChart;
    public chartProps: any;

    private delayRefresh: boolean = false;

    constructor(private chartUtilities: ChartUtilitiesService, public dialog: MatDialog) { }

    ngOnInit(): void {
        this.notifier.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
            this.splicedData = this.data;
            this.generateChart();
        });

        if (this.isStandAlone) {
            this.downloadDialogNotifier.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
                this.downloadChart();
            });
        }
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    downloadChart() {
        const dialogRef = this.dialog.open(DialogDownloadTableComponent, {
            panelClass: 'dialog-download-pannel',
            backdropClass: "backdrop-invisible",
            data: {
                fileName: this.reportCode,
                fileType: "PDF",
                fileTypes: ["PDF", "PNG", "JPEG", "SVG"],
                isChart: true
            },
            width: "495px",
            height: "370px"
        });

        dialogRef.afterClosed().subscribe(data => {
            if (data) {
                let fileName = data.fileName;
                let fileType = data.fileType;
                let width = data.imgWidth;
                let height = data.imgHeight;
                let type: any;
                if (width > 3000) width = 3000;
                if (width < 1900) width = 1900;
                if (height > 1800) height = 1800;
                if (height < 1000) height = 1000;
                switch (fileType) {
                    case "PDF": type = "application/pdf"; break;
                    case "PNG": type = "image/png"; break;
                    case "JPEG": type = "image/jpeg"; break;
                    case "SVG": type = "image/svg+xml"; break;
                    default: type = "application/pdf"; break;
                }
                let chartOptions = {
                    title: {
                        text: this.reportInfo
                    },
                    chart: {
                        width: width,
                        height: height,

                    }
                }
                this.chart.ref.exportChart(
                    {
                        type: type,
                        filename: fileName
                    },
                    chartOptions
                )
            }
        });
    }

    onResized(event: ResizedEvent) {
        if (this.delayRefresh) return;
        this.delayRefresh = true;
        setTimeout(() => {
            this.delayRefresh = false;
            this.generateChart();
        }, 20);
    }

    generateChart() {
        setTimeout(() => {
            if (this.stepper) {
                if (this.stepper._selectedIndex === 1) {
                    // 
                }

                if (this.stepper._selectedIndex === 2) {
                    if (this.groupByTime?.trim().length > 0) {
                        this.sortDataByDate();
                        this.createChartWithGrouping();
                    } else {
                        this.createChart();
                    }
                }
            } else {
                if (this.chart) {
                    this.chart = this.createChartBase(this.chartProps);
                } else {
                    if (this.groupByTime?.trim().length > 0) {
                        this.sortDataByDate();
                        this.createChartWithGrouping();
                    } else {
                        this.createChart();
                    }
                }
            }
        }, 0);
    }

    getMultipleKeySeries(id, compositeKeys, uniqueCategories): any {
        let multiInfo = {
            series: [],
            categories: []
        };
        let length = 0;
        let series = [];
        let categories = [];
        let compositeKeyIds = compositeKeys.map(k => k.id);
        let sortedKeys = compositeKeys.filter(k => k.id !== id).sort((a, b) => a.order - b.order).map(k => k.id);

        for (let i = 0; i < this.gridItem.setup.columns?.length; i++) {
            let column = this.gridItem.setup.columns[i];
            if (compositeKeyIds.indexOf(column) > -1) continue;
            let columnInfo = this.columns.find(c => c.id === column);

            let seriesObj = {
                name: columnInfo?.name,
                data: []
            }

            for (let j = 0; j < uniqueCategories.length; j++) {
                let catData = this.splicedData.filter(d => d[id] === uniqueCategories[j]);

                let categoryName = uniqueCategories[j] || '';
                let categoryNameTokens = categoryName.split(' ');
                let spacesInString = categoryNameTokens.length - 1;
                let currentLength = 0;

                if (categoryName.toString().length > 12 && spacesInString === 1) {
                    categoryName = categoryName.toString().replace(' ', '<br/>');
                    currentLength = categoryName.split("<br/>")[0].length > categoryName.split("<br/>")[1].length ?
                        categoryName.split("<br/>")[0].length :
                        categoryName.split("<br/>")[1].length;
                }

                if (categoryName.toString().length > 12 && spacesInString > 1) {
                    categoryName = categoryName.toString().replace(' ', '<br/>');
                    currentLength = categoryName.split("<br/>")[0].length > categoryName.split("<br/>")[1].length ?
                        categoryName.split("<br/>")[0].length :
                        categoryName.split("<br/>")[1].length;
                }

                if (spacesInString === 0) {
                    currentLength = categoryName.toString().length;
                }

                length = currentLength > length ? currentLength : length;

                let categoryObject = {
                    name: categoryName,
                    categories: []
                };

                for (let l = 0; l < catData.length; l++) {
                    let category = categoryName;
                    seriesObj["data"].push(catData[l][column]);
                    let value = catData[l][sortedKeys[0]] || "";

                    if (sortedKeys.length === 1) {
                        category += `<br/>${value}`;
                    }
                    if (sortedKeys.length === 2) {
                        category += `<br/>${value}<br/>${catData[l][sortedKeys[1]] || ""}`;
                    }
                    if (sortedKeys.length === 3) {
                        category += `<br/>${value}<br/>${catData[l][sortedKeys[1]] || ""}<br/>${catData[l][sortedKeys[2]] || ""}`;
                    }

                    categories.push(`${category}`);
                }

            }
            series.push(seriesObj);
        }

        this.longestStringLength = length;

        multiInfo.series = series;
        multiInfo.categories = categories;

        return multiInfo;
    }

    getSingleKeySeries(id, compositeKeys, categories, uniqueCategories): any[] {
        let series = [];
        let compositeKeyIds = compositeKeys.map(k => k.id);

        for (let i = 0; i < this.gridItem.setup.columns?.length; i++) {
            let column = this.gridItem.setup.columns[i];
            if (compositeKeyIds.indexOf(column) > -1) continue;
            let columnInfo = this.columns.find(c => c.id === column);

            let seriesObj = {
                name: columnInfo?.name,
                data: []
            }

            for (let j = 0; j < this.splicedData.length; j++) {
                let catData = this.splicedData[j];
                let value = catData[column];
                seriesObj["data"].push(value);
            }

            series.push(seriesObj);
        }

        return series;
    }

    createChart(): void {
        const id = this.getId();
        const compositeKeys = this.getCompositeKeys() || [];
        let categories = this.splicedData.map(d => d[id]);

        if (this.columns) {
            if (compositeKeys.length > 1) {
                this.createChartWithCompositeKeys(id, compositeKeys, categories);
            } else {
                this.createMultipleSeriesChart(id, compositeKeys, categories);
            }
        }
    }

    createChartWithGrouping(): void {
        const id = this.getId();
        const compositeKeys = this.getCompositeKeys() || [];
        const groupingValue = this.groupByTime;
        let categories = [];
        let series = [];

        let type = gridItemType[this.gridItem.type];

        let seriesCounter = 0;
        let formattedData = [];

        for (let i = 0; i < this.splicedData.length; i++) {

            let formattedInfo = this.splicedData[i];
            formattedInfo[groupingValue] = this.chartUtilities.getGroupingValue(groupingValue, formattedInfo["__from__"], formattedInfo["__to__"], "<br/>");

            formattedData.push(formattedInfo);
        }

        let keys = Object.keys(this.splicedData[0]);

        if (compositeKeys.length === 1) {
            let keyName = compositeKeys[0].id;
            let valueKeys = keys.filter(function (value, index, arr) {
                return value.toLowerCase() !== id &&
                    value.toLowerCase() !== "__from__" &&
                    value.toLocaleLowerCase() !== "__to__" &&
                    value.toLocaleLowerCase() !== groupingValue.toLocaleLowerCase();
            });

            for (let i = 0; i < formattedData.length; i++) {
                let timeCategory = formattedData[i][this.groupByTime];
                let subCategory = formattedData[i][keyName];
                if (groupingValue === "H" || groupingValue === "W" || groupingValue === "Q") {
                    if (this.longestStringLength < timeCategory.split("<br/>")[0].length) {
                        this.longestStringLength = timeCategory.split("<br/>")[0].length;
                    }
                    if (this.longestStringLength < timeCategory.split("<br/>")[1].length) {
                        this.longestStringLength = timeCategory.split("<br/>")[1].length;
                    }
                } else {
                    if (this.longestStringLength < timeCategory.length) {
                        this.longestStringLength = timeCategory.length;
                    }
                }

                categories.push(`${subCategory}<br/>${timeCategory}`);

                for (let j = 0; j < valueKeys.length; j++) {
                    let key = valueKeys[j];
                    let value = this.splicedData[i][key];
                    let keyName = this.columns.find(c => c.id === key)?.name;

                    let seriesLength = series.filter(s => s["name"] === keyName).length;
                    if (seriesLength === 0) {
                        series.push({ name: keyName, type: type, data: [value] });
                    } else {
                        let serieEntry = series.find(c => c["name"] === keyName);
                        serieEntry["data"].push(value);
                    }
                }
            }
        }

        if (compositeKeys.length === 2) {
            let highOrderCompositeKey = compositeKeys.find(ck => ck["order"] === 0);
            let lowOrderCompositeKey = compositeKeys.find(ck => ck["order"] === 1);

            let valueKeys = keys.filter(function (value, index, arr) {
                return value.toLowerCase() !== highOrderCompositeKey.id &&
                    value.toLowerCase() !== lowOrderCompositeKey.id &&
                    value.toLowerCase() !== "__from__" &&
                    value.toLocaleLowerCase() !== "__to__" &&
                    value.toLocaleLowerCase() !== groupingValue.toLocaleLowerCase();
            });

            for (let i = 0; i < formattedData.length; i++) {
                let timeCategory = formattedData[i][this.groupByTime];
                let highSubCategory = formattedData[i][highOrderCompositeKey.id];
                let lowSubCategory = formattedData[i][lowOrderCompositeKey.id];
                let categoryLength = categories.filter(c => c["name"] === timeCategory).length;
                if (groupingValue === "H" || groupingValue === "W" || groupingValue === "Q") {
                    if (this.longestStringLength < timeCategory.split("<br/>")[0].length) {
                        this.longestStringLength = timeCategory.split("<br/>")[0].length;
                    }

                    if (this.longestStringLength < timeCategory.split("<br/>")[1].length) {
                        this.longestStringLength = timeCategory.split("<br/>")[1].length;
                    }
                } else {
                    if (this.longestStringLength < timeCategory.length) {
                        this.longestStringLength = timeCategory.length;
                    }
                }

                categories.push(`${lowSubCategory}<br/>${highSubCategory}<br/>${timeCategory}`);

                for (let j = 0; j < valueKeys.length; j++) {
                    let key = valueKeys[j];
                    let value = this.splicedData[i][key];
                    let keyName = this.columns.find(c => c.id === key)?.name;

                    let seriesLength = series.filter(s => s["name"] === keyName).length;
                    if (seriesLength === 0) {
                        series.push({ name: keyName, type: type, data: [value] });
                    } else {
                        let serieEntry = series.find(c => c["name"] === keyName);
                        serieEntry["data"].push(value);
                    }
                }
            }
        }

        if (compositeKeys.length === 3) {
            let highOrderCompositeKey = compositeKeys.find(ck => ck["order"] === 0);
            let midOrderCompositeKey = compositeKeys.find(ck => ck["order"] === 1);
            let lowOrderCompositeKey = compositeKeys.find(ck => ck["order"] === 2);

            let valueKeys = keys.filter(function (value, index, arr) {
                return value.toLowerCase() !== highOrderCompositeKey.id &&
                    value.toLowerCase() !== midOrderCompositeKey.id &&
                    value.toLowerCase() !== lowOrderCompositeKey.id &&
                    value.toLowerCase() !== "__from__" &&
                    value.toLocaleLowerCase() !== "__to__" &&
                    value.toLocaleLowerCase() !== groupingValue.toLocaleLowerCase();
            });

            for (let i = 0; i < formattedData.length; i++) {
                let timeCategory = formattedData[i][this.groupByTime];
                let highSubCategory = formattedData[i][highOrderCompositeKey.id];
                let midSubCategory = formattedData[i][midOrderCompositeKey.id];
                let lowSubCategory = formattedData[i][lowOrderCompositeKey.id];

                let categoryLength = categories.filter(c => c["name"] === timeCategory).length;
                if (categoryLength === 0) {
                    categories.push({
                        name: timeCategory,
                        categories: [{
                            name: highSubCategory,
                            categories: [{
                                name: midSubCategory,
                                categories: [lowSubCategory]
                            }]
                        }]
                    });
                } else {
                    let categoryEntry = categories.find(c => c["name"] === timeCategory);
                    let subCategoryLength = categoryEntry["categories"].filter(c => c["name"] === highSubCategory).length;
                    if (subCategoryLength === 0) {
                        categoryEntry["categories"].push({
                            name: highSubCategory,
                            categories: [{
                                name: midSubCategory,
                                categories: [lowSubCategory]
                            }]
                        });
                    } else {
                        let subCategoryEntry = categoryEntry["categories"].find(c => c["name"] === highSubCategory);
                        let midCategoryLength = subCategoryEntry.filter(c => c["name"] === midSubCategory).length;
                        if (midCategoryLength.length === 0) {
                            subCategoryEntry.push({
                                name: midSubCategory,
                                categories: [lowSubCategory]
                            })
                        } else {
                            let midCategoryEntry = categoryEntry["categories"]["categories"].find(c => c["name"] === midSubCategory);
                            midCategoryEntry["categories"].push(lowSubCategory);
                            seriesCounter++;
                        }
                    }
                }
            }
        }

        let shouldAddScroll = seriesCounter > 15 ? true : false;
        let pxLength = 9;
        let minWidth = pxLength * this.longestStringLength * seriesCounter;

        let xAxis: any = {
            labels: {
                groupedOptions: [{
                    style: {
                        "text-align": "center"
                    },
                }, {
                    style: {
                        "text-align": "center"
                    },
                }, {
                    style: {
                        "text-align": "center"
                    },
                }],
            },
            categories: categories
        }

        const chartProps = {
            minWidth: shouldAddScroll ? minWidth : 0,
            xAxis,
            series,
            scrollPositionX: 0,
            rules: [
                responsiveChart.height200,
                responsiveChart.height350
            ]
        };

        this.chartProps = chartProps;

        this.chart = this.createChartBase(chartProps);
    }

    createChartWithCompositeKeys(id, compositeKeys, categories): void {
        const uniqueCategories = categories.filter((item, i, ar) => ar.indexOf(item) === i);

        let multiInfo = this.getMultipleKeySeries(id, compositeKeys, uniqueCategories);
        let series = multiInfo.series;
        let seriesCategories = multiInfo.categories;
        let seriesCounter = series.length > 0 ? series[0].data.length : 0;

        let shouldAddScroll = false;
        let pxLength = 9;
        let minWidth = 0;
        if (seriesCounter >= 15) {
            shouldAddScroll = true;
            minWidth = pxLength * this.longestStringLength * seriesCounter;
        }

        let xAxis: any = {
            labels: {
                groupedOptions: [{
                    style: {
                        "text-align": "center"
                    },
                }, {
                    style: {
                        "text-align": "center"
                    },
                }, {
                    style: {
                        "text-align": "center"
                    },
                }]
            },
            categories: seriesCategories
        }

        const chartProps = {
            minWidth: shouldAddScroll ? minWidth : 0,
            xAxis,
            series,
            scrollPositionX: 0,
            rules: [
                responsiveChart.height200,
                responsiveChart.height350
            ]
        };

        this.chartProps = chartProps;

        this.chart = this.createChartBase(chartProps);
    }

    createMultipleSeriesChart(id, compositeKeys, categories): void {
        const uniqueCategories = categories.filter((item, i, ar) => ar.indexOf(item) === i).map(c => c || "");
        categories = categories.map(c => c || "");
        let series = [...this.getSingleKeySeries(id, compositeKeys, categories, uniqueCategories)];

        let minWidth = 1000;

        const chartProps = {
            xAxis: {
                categories: categories,
                title: {
                    text: '',
                    style: {
                        fontSize: '14px'
                    }
                }
            },
            minWidth,
            series,
            rules: [
                responsiveChart.height200,
                responsiveChart.height300
            ]
        }

        this.chartProps = chartProps;

        this.chart = this.createChartBase(chartProps);
    }

    private sortDataByDate(): void {
        if (this.groupByTime?.trim().length > 0) {
            this.splicedData.sort((a, b) => {
                return new Date(a["__from__"]).getTime() - new Date(b["__from__"]).getTime()
            })
        }
    }

    private getColorTheme() {
        let colorScheme = this.gridItem.colorScheme;
        if (this.isStandAlone) colorScheme = 0;
        const theme: Highcharts.Options = multiColorThemes[colorScheme !== null ? colorScheme : 0];

        return theme;
    }

    private getId() {
        return this.columns?.filter(c => c.isKey).sort((a, b) => a.keyOrder - b.keyOrder)[0].id;
    }

    private getCompositeKeys() {
        return this.columns?.filter(c => c.isKey).map(c => ({ id: c.id, order: c.keyOrder }));
    }

    private getLabelValue(columnId, names): string {
        return names.filter(column => column.id === columnId)[0]?.name;
    }

    private getFontSizeValue(fontId, fonts): string {
        return fonts.filter(font => font.id === fontId)[0]?.fontSize;
    }

    private getColorValue(colorId, colors): string {
        return colors.filter(color => color.id === colorId)[0]?.color;
    }

    private getDefaultColorValues(): string {
        if (this.gridItem.colorScheme === 3) {
            return "#FFFFFF";
        }

        return "#30424F";
    }

    private createChartBase({
        series,
        minWidth = 0,
        scrollPositionX = undefined,
        xAxis,
        rules = undefined
    }) {
        const { names, fonts, colors } = Object(this.gridItem.setup?.preferences);
        const here = this;

        this.legendTitle = names && this.getLabelValue(widgetAppearanceType.LeggendTitle, names) || '';
        this.xTitle = names && this.getLabelValue(widgetAppearanceType.XAxisTitle, names) || '';
        this.yTitle = names && this.getLabelValue(widgetAppearanceType.YAxisTitle, names) || '';

        this.legendFontSize = fonts && this.getFontSizeValue(widgetAppearanceType.LeggendTitle, fonts) || '';
        this.legendElementsFontSize = fonts && this.getFontSizeValue(widgetAppearanceType.LeggendElements, fonts) || '';
        this.xTitleFontSize = fonts && this.getFontSizeValue(widgetAppearanceType.XAxisTitle, fonts) || '';
        this.xLabelsFontSize = fonts && this.getFontSizeValue(widgetAppearanceType.XAxisLables, fonts) || '';
        this.yTitleFontSize = fonts && this.getFontSizeValue(widgetAppearanceType.YAxisTitle, fonts) || '';
        this.yLabelsFontSize = fonts && this.getFontSizeValue(widgetAppearanceType.YAxisLables, fonts) || '';

        this.legendColor = colors && this.getColorValue(widgetAppearanceType.LeggendTitle, colors) || this.getDefaultColorValues();
        this.legendElementsColor = colors && this.getColorValue(widgetAppearanceType.LeggendElements, colors) || this.getDefaultColorValues();
        this.xTitleColor = colors && this.getColorValue(widgetAppearanceType.XAxisTitle, colors) || this.getDefaultColorValues();
        this.xLabelsColor = colors && this.getColorValue(widgetAppearanceType.XAxisLables, colors) || this.getDefaultColorValues();
        this.yTitleColor = colors && this.getColorValue(widgetAppearanceType.YAxisTitle, colors) || this.getDefaultColorValues();
        this.yLabelsColor = colors && this.getColorValue(widgetAppearanceType.YAxisLables, colors) || this.getDefaultColorValues();

        let theme = this.getColorTheme();

        let categories = xAxis.categories;

        return new StockChart({
            chart: {
                ...theme.chart,
                events: {
                    load: function () {
                        Highcharts.addEvent(this.tooltip, 'headerFormatter', function (e: any) {
                            if (!e.isFooter) {
                                e.text = xAxis.categories[e.labelConfig.x];
                            }
                        });
                    },
                    render: function () {
                        const elements = here.htmlChart.nativeElement.querySelectorAll(".highcharts-navigator > *");
                        const scrollBars = document.querySelectorAll(".highcharts-scrollbar-thumb");
                        scrollBars.forEach(sb => sb.classList.add('gridster-item-content'));
                        elements.forEach(e => e.classList.add('gridster-item-content'));
                    }
                },
                type: gridItemType[this.gridItem.type]
            },
            yAxis: {
                crosshair: false,
                opposite: false,
                title: {
                    text: this.yTitle,
                    style: {
                        fontSize: this.yTitleFontSize,
                        color: this.yTitleColor
                    }
                },
                labels: {
                    formatter: function () {
                        return here.formatYAxis(this.value);
                    },
                    style: {
                        fontSize: this.yLabelsFontSize,
                        color: this.yLabelsColor
                    }
                }
            },
            xAxis: {
                crosshair: false,
                title: {
                    text: this.xTitle,
                    margin: 10,
                    style: {
                        fontSize: this.xTitleFontSize,
                        color: this.xTitleColor
                    }
                },
                labels: {
                    formatter: function () {
                        return xAxis.categories[this.value];
                    },
                    autoRotation: [-90],
                    autoRotationLimit: 300,
                    style: {
                        fontSize: this.xLabelsFontSize,
                        color: this.xLabelsColor,
                        textOverflow: 'ellipsis'
                    }
                }
            },
            series: series,
            legend: {
                enabled: true,
                title: {
                    text: this.legendTitle,
                    style: {
                        fontSize: this.legendFontSize,
                        color: this.legendColor
                    }
                },
                itemStyle: {
                    fontFamily: 'Quicksand',
                    fontSize: this.legendElementsFontSize,
                    color: this.legendElementsColor
                }
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            rangeSelector: {
                enabled: false
            },
            navigator: {
                xAxis: {
                    labels: {
                        formatter: function (event) {
                            return "";
                        }
                    }
                }
            },
            plotOptions: {
                series: {
                    animation: false,
                    marker: {
                        enabled: true,
                        radius: 4
                    }
                }
            },
            tooltip: {
                split: false,
                shared: true,
                pointFormatter: function () {
                    let dataIndex = this.x;
                    let valueIndex = this.series["index"];
                    let category = series[valueIndex];
                    let name = category["name"];
                    let value = category["data"][dataIndex];
                    let serie = here.columns.find(c => name == c.name);
                    let formattedValue = here.formatValue(value, serie?.format);
                    let currentSerie: any = this.series;

                    return `<br/><span style="color:${currentSerie.color}">${currentSerie.name}</span>: <b>${formattedValue}</b>`;
                }
            },
            colors: theme.colors,
            responsive: {
                rules
            }
        });
    }

    formatYAxis(value) {
        let series = this.columns.filter(c => this.gridItem.setup.columns.indexOf(c.id) >= 0 && !c.isKey);
        let chartSeries = this.chart.ref?.series;
        if (chartSeries) {
            series = series.filter(s => chartSeries.find(cs => cs.name == s.name && cs.visible));
        }
        let formats = [...new Set(series.map(s => {
            switch (s.format) {
                case "SecToTimeFloor": return "SecToTime";
                case "%1":
                case "%2": return "%";
                case "Round0":
                case "Round2": return "";
                default: return s.format;
            }
        }))];

        let result: string = "";
        if (value != null) {
            if (formats.length == 1) {
                result = this.formatValue(value, formats[0]);
            } else {
                result = value;
            }
        }
        return `<span>${result}</span>`
    }

    formatValue(value, format) {
        switch (format) {
            case "Date": return dateTimeToDate(value);
            case "Time": return dateTimeToTime(value);
            case "SecToTimeFloor": return secondsToTime(value, true);
            case "SecToTime": return secondsToTime(value);
            case "%": return percentages(value, 0);
            case "%1": return percentages(value, 1);
            case "%2": return percentages(value, 2);
            case "1%": return percentages(value, 1);
            case "2%": return percentages(value, 2);
            case "Round0": return round(value, 0);
            case "Round2": return round(value, 2);
            default: return value;
        }
    }
}
